import { SystemEventTypeEnum } from '@libs/types';
import { eventBus } from '@libs/utils';
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useEffect, useRef, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { zIndex } from '../utils/constants';
import { Div } from '../utils/styled';

const widgetUid = 'ToastBar';
export const ToastBar = () => {
    const timerId = useRef(0);
    const [toastMessage, setToastMessage] = useState('');
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    const close = () => {
        clearTimeout(timerId.current);
        timerId.current = 0;
        setToastMessage('');
    };

    useEffect(() => {
        eventBus.subscribe(SystemEventTypeEnum.TOAST_MESSAGE, widgetUid, (message) => {
            setToastMessage(message as unknown as string);
        });
        if (toastMessage) {
            if (timerId.current) {
                return;
            }
            timerId.current = setTimeout(close, 2500) as unknown as number;
        }
        return () => {
            clearTimeout(timerId.current);
            eventBus.unsubscribe(SystemEventTypeEnum.TOAST_MESSAGE, widgetUid);
        };
    }, [toastMessage]);

    const onSwipe = useSwipeable({
        onSwipedUp: () => close(),
        trackTouch: true,
    });

    const toastBar = (
        <Div data-test="toastBar" sx={{ left: 0, position: 'fixed', right: 0, top: '24px', pointerEvents: 'none', zIndex: zIndex.toast }}>
            <Div
                sx={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    maxWidth: '432px',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                }}
            >
                <Div
                    sx={(theme: Theme) => ({
                        color: prefersDarkMode ? 'common.black' : 'common.white',
                        backgroundColor: prefersDarkMode ? 'common.white' : 'common.black',
                        borderRadius: '12px',
                        boxShadow: theme.shadows[4],
                        padding: '16px 24px',
                        pointerEvents: 'initial',
                        cursor: 'pointer',
                    })}
                    {...onSwipe}
                    data-testid={widgetUid}
                    onClick={close}
                >
                    {toastMessage}
                </Div>
            </Div>
        </Div>
    );
    return toastMessage ? toastBar : null;
};
